import React from "react";
import NoDataUser from "../assets/images/not-found.png";
import ArrowLeft from "../assets/images/left-arrow.png";
import { useLocation, useNavigate } from "react-router-dom";

const NotFound = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <>
      {/* <div className="project-details">
        <div
          style={{ display: "flex", justifyContent: "right" }}
          className="timesheet"
        >
          <div className="options">
            <SideDropDownOptions />
          </div>
        </div>
      </div> */}
      <div className="not-found">
        {pathname !== "/no-data" && (
          <button
            className="primary-btn back-btn mb-4"
            onClick={() => navigate(-1)}
          >
            <img src={ArrowLeft} />
          </button>
        )}
        <div className="content">
          {pathname !== "/no-data" ? (
            <img src={NoDataUser} className="img-fluid image" alt="" />
          ) : (
            <img src={NoDataUser} className="img-fluid image" alt="" />
          )}
          {pathname !== "/no-data" && (
            <h2 className="title">
              The page you are looking for does not exist or removed
            </h2>
          )}
          {pathname === "/no-data" && (
            <h2 className="title">
              Oops, you are not associated with any crews or timecards. Please
              contact your administrator.
            </h2>
          )}
        </div>
      </div>

    </>
  );
};

export default NotFound;
